import { render, staticRenderFns } from "./deployContract.vue?vue&type=template&id=05b4f9ba&scoped=true&"
import script from "./deployContract.vue?vue&type=script&lang=js&"
export * from "./deployContract.vue?vue&type=script&lang=js&"
import style0 from "./deployContract.vue?vue&type=style&index=0&id=05b4f9ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4f9ba",
  null
  
)

export default component.exports